import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/* eslint-disable no-console */
import React, { useContext, useEffect, useState } from 'react';
import { GoogleReCaptchaProvider, GoogleReCaptchaContext } from 'react-google-recaptcha-v3';
import { DEFAULT_RETRIES, DEFAULT_TIMEOUT_MS } from './RecaptchaProvider.constants';
import { RecaptchaContextProvider } from './RecaptchaProvider.context';
import { getSiteKey, isRecaptchaProviderDefined, isRecaptchaProviderLoaded, isRecaptchaInjectedInDom } from './RecaptchaProvider.utils';
import { ChildrenPropType } from '../../services/proptypes';
import './RecaptchaProvider.css';
var defaultProps = {
  siteKey: getSiteKey(),
  attempts: DEFAULT_RETRIES,
  timeout: DEFAULT_TIMEOUT_MS
};
export default function RecaptchaProvider(_ref) {
  var children = _ref.children,
    siteKey = _ref.siteKey,
    timeout = _ref.timeout,
    attempts = _ref.attempts;
  var context = useContext(GoogleReCaptchaContext);
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    attempt = _useState2[0],
    setAttempt = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    recaptchaLoaded = _useState4[0],
    setRecaptchaLoaded = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    attemptRecaptchaReload = _useState6[0],
    setAttemptRecaptchaReload = _useState6[1];
  var scriptId = "google-recaptcha-v3-script_".concat(attempt);
  useEffect(function () {
    setAttemptRecaptchaReload(!isRecaptchaProviderDefined(context));
  }, []);
  useEffect(function () {
    if (attemptRecaptchaReload) {
      var timeoutId = setTimeout(function () {
        if (!siteKey || isRecaptchaProviderLoaded(context) || isRecaptchaInjectedInDom()) {
          console.log("Recaptcha loaded after ".concat(attempt, " extra attempts!"));
          setRecaptchaLoaded(true);
          clearTimeout(timeoutId);
        } else if (attempt >= attempts || attempts === 0) {
          console.error("Couldn't load Recaptcha after ".concat(attempts, " attempts"));
          clearTimeout(timeoutId);
        } else {
          console.warn("Retrying Recaptcha load attempt ".concat(attempt + 1, "..."));
          setAttempt(function (currentAttempt) {
            return currentAttempt + 1;
          });
        }
      }, timeout);
      return function () {
        clearTimeout(timeoutId);
      };
    }
    return undefined;
  }, [attempt, attemptRecaptchaReload]);
  if (!siteKey) {
    return /*#__PURE__*/React.createElement(RecaptchaContextProvider, {
      value: {
        loaded: recaptchaLoaded,
        setLoaded: setRecaptchaLoaded
      }
    }, children);
  }

  // Provider already exists in the hierarchy; don't duplicate
  if (isRecaptchaProviderDefined(context)) {
    return children;
  }
  return /*#__PURE__*/React.createElement(RecaptchaContextProvider, {
    value: {
      loaded: recaptchaLoaded,
      setLoaded: setRecaptchaLoaded
    }
  }, /*#__PURE__*/React.createElement(GoogleReCaptchaProvider, {
    reCaptchaKey: siteKey,
    language: "en",
    useRecaptchaNet: true,
    useEnterprise: true,
    scriptProps: {
      async: true,
      defer: true,
      appendTo: 'head',
      nonce: undefined,
      id: scriptId
    },
    container: {
      // this will trick the library to recreate the memoized context and refresh it
      element: attempt % 2 === 0 ? null : undefined
    }
  }, children));
}
RecaptchaProvider.defaultProps = defaultProps;